import moment from "moment";
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";

let colors = ["black", "orange", "green", "darkblue", "blue", "#89d129", "#29c1d1", "darkyellow", "red", "darkgreen", "cyan", "#dfdc90", "#76356", "#76FF65", "#00FF65", "#00FF65", "#d12929"];

// let lobOptions = {
// 	Food: { label: "Food", color: "black" },
// 	FlightOTA: { label: "FlightOTA", color: "orange" },
// 	Hotel: { label: "Hotel", color: "green" },
// 	AAXpress: { label: "AAXpress", color: "blue" },
// 	Beauty: { label: "Beauty", color: "#89d129" },
// 	OurFresh: { label: "OurFresh", color: "#29c1d1" },
// 	Activities: { label: "Activities", color: "darkyellow" },
// 	Deal: { label: "Deal", color: "red" },
// 	Health: { label: "Health", color: "darkgreen" },
// 	Shop: { label: "Shop", color: "cyan" },
// 	AARide: { label: "AARide", color: "#dfdc90" },
// 	ExtendedFlightOTA: { label: "Extended FlightOTA", color: "#763565" },
// 	ExtendedAARide: { label: "Extended AARide", color: "#76FF65" },
// 	Insurance: { label: "Insurance", color: "#00FF65" },
// 	IKHLAS: { label: "Ikhlas", color: "#00FF65" },
// 	SettlementAARide: { label: "Settlement AARide", color: "#d12929" },
// };

const TrendLineByLOB = ({ data }) => {
	const timelineLabels = useMemo(() => {
		let labels = [];
		if (Object.keys(data).length > 0) {
			let anyKey = Object.keys(data)[0];
			let startX = data[anyKey].startX;
			let endX = data[anyKey].endX;
			let groupByPeriod = data[anyKey].groupByPeriod;
			while (startX < endX) {
				labels.push(moment(startX).format("HH:mm"));
				startX += groupByPeriod;
			}
		}
		return labels;
	}, [data]);

	const builddataData = () => {
		let datasets = [];
		Object.keys(data).forEach((key, index) => {
			datasets.push({
				data: data[key].values,
				backgroundColor: colors[index],
				borderColor: colors[index],
				elements: { point: { radius: 1 } },
				borderWidth: 1,
				label: key,
				lineTension: 0,
			});
		});
		let result = {
			labels: timelineLabels,
			datasets: datasets,
			bezierCurve: false,
		};
		return result;
	};

	return (
		<Line
			data={builddataData()}
			options={{
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: true,
						position: "top",
					},
				},
			}}
		/>
	);
};

export default TrendLineByLOB;
